import React from 'react';
import PropTypes from "prop-types";
export default function Space(props) {
  if (!props.count) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, "\xA0");
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, Array(props.count).fill(0).map(function (o, idx) {
    return /*#__PURE__*/React.createElement("span", {
      key: idx
    }, "\xA0");
  }));
}
Space.propTypes = {
  count: PropTypes.number
};